import { memo, useRef } from "react";
import classnames from "classnames";
import { useThemeModeContext } from "../../core/ThemeMode/ThemeModeContext";

import { ReactComponent as AutoIcon } from "./images/icon-button-light-auto.svg";
import { ReactComponent as LightIcon } from "./images/icon-light.svg";
import { ReactComponent as NightIcon } from "./images/icon-night.svg";

import styles from "./style.module.scss";


export type ThemeModeSwitcherProps = {
  className?: string,
}

export const ThemeModeSwitcher = memo<ThemeModeSwitcherProps>(({ className }) => {

  const { theme, userPreferredTheme, setUserPreferredTheme } = useThemeModeContext();
  const containerRef = useRef<HTMLDivElement>(null);

  const autoActive = userPreferredTheme === null;
  const lightActive = userPreferredTheme === "light";
  const nightActive = userPreferredTheme === "dark";

  return (
    <div
      ref={containerRef}
      className={classnames(
        className,
        styles.root,
        {
          [styles.auto]: autoActive,
          [styles[theme]]: !autoActive,
        },
      )}
    >
      <button
        className={styles.button}
        data-active={lightActive}
        onClick={() => setUserPreferredTheme("light")}>
        <LightIcon />
      </button>
      <button
        className={styles.button}
        data-active={nightActive}
        onClick={() => setUserPreferredTheme("dark")}
      >
        <NightIcon />
      </button>
      <button
        className={styles.button}
        data-active={autoActive}
        onClick={() => setUserPreferredTheme(null)}
      >
        <AutoIcon />
      </button>
    </div>
  );
});